import Grid2, { type Grid2Props } from '@mui/material/Unstable_Grid2';

import { ViewportSize } from '@/styles/viewportSize';

import useStyles from './GridContainer2.styles';

export const gridMargins: { [K in ViewportSize]: number } = {
  [ViewportSize.xs]: 24,
  [ViewportSize.sm]: 40,
  [ViewportSize.md]: 64,
  [ViewportSize.lg]: 80,
  [ViewportSize.xl]: 80,
};

interface GridContainer2Props {
  children: React.ReactNode;
  fixed?: boolean;
  wrapperProps?: React.HTMLAttributes<HTMLDivElement>;
  gridProps?: Grid2Props;
}

export default function GridContainer2({
  children,
  fixed,
  wrapperProps,
  gridProps,
}: GridContainer2Props) {
  const { classes, cx } = useStyles();

  return (
    <div
      {...wrapperProps}
      className={cx(
        classes.wrapper,
        { [classes.fixed]: fixed },
        wrapperProps?.className
      )}
    >
      <Grid2
        container
        spacing={{ xs: 2, sm: 3, lg: 4 }}
        rowSpacing={'0px'}
        {...gridProps}
      >
        {children}
      </Grid2>
    </div>
  );
}
